export default `
<section>
  <h2>LEGAL NOTICE
  </h2>
  <p>The InnoCAPE (Industry 4: transforming innovation ecosystem through better capacity of public enablers) is the
    project supported by Interreg BSR program and maintains the websites under domain *
    <a target="_blank" href="https://innocape.eu" rel="noopener noreferrer">.innocape.eu
    </a>.
  </p>
  <section>
    <h3>The controller of the websites and the processing your personal data
    </h3>
    <p>Sunrise valley science and technology park
    </p>
    <p>Company ID in Lithuanian Centre of Registers: 3126224832
    </p>
    <p>Address: Saulėtekio al. 15, LT-10224 Vilnius
    </p>
    <p>Contact via online form:
      <a target="_blank" href="https://ssmtp.lt/en/contacts/" rel="noopener noreferrer">https://ssmtp.lt/en/contacts/
      </a>
    </p>
    <p>The website www.innocape.eu is governed by Lithuanian law.
    </p>
  </section>
  <section>
    <h3>Editorial team
    </h3>
    <p>The content of the websites are created by the Communication team of the InnoCAPE project partners:
      <a target="_blank" href="https://innocape.eu/#partners" rel="noopener noreferrer">https://innocape.eu/#partners
      </a>
    </p>
  </section>
  <section>
    <h3>Copyright
    </h3>
    <p>© InnoCAPE, 2020
    </p>
    <p>Reproduction of images, videos and other content is authorised for non-commercial purposes, provided the source
      is acknowledged, except where otherwise stated. Where prior permission must be obtained for the reproduction or
      use of textual and multimedia information (sound, images, software, etc.), such permission shall cancel the
      above-mentioned general permission and shall clearly indicate any restrictions on use.
    </p>
  </section>
  <section>
    <h3>External content
    </h3>
    <p>Our website contains various hyperlinks towards external websites as well as embedded social media feeds.
      InnoCAPE is not responsible for the context of the external websites and social media accounts which is not
      managed by InnoCAPE Editorial team.
    </p>
  </section>
  <section>
    <h3>Project websites
    </h3>
    <p>Our website hosts several individual project micro-sites. Responsibility of the content of those websites is
      under the Lead partner of InnoCAPE the project -
      <a target="_blank" href="https://ssmtp.lt/en" rel="noopener noreferrer">Sunrise valley science &amp; technology
        park
      </a>.
    </p>
  </section>
  <section>
    <h3>Hosting
    </h3>
    <p>The
      <a target="_blank" href="https://www.innocape.eu" rel="noopener noreferrer">www.innocape.eu
      </a> website is hosted by "Telia Lietuva"; AB, Vilnius Lithuania (
      <a target="_blank" href="https://www.hostex.lt" rel="noopener noreferrer">www.hostex.lt
      </a>). The
      <a target="_blank" href="https://dma.innocape.eu" rel="noopener noreferrer">dma.innocape.eu
      </a> (DMA) website is hosted by SIA “CUBE Systems” (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>), Riga Latvija (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>). The
      <a target="_blank" href="https://cmap.innocape.eu" rel="noopener noreferrer">cmap.innocape.eu
      </a> (CMAP) website is hosted by SIA “Gstream“ (
      <a target="_blank" href="https://www.easyhosting.lv" rel="noopener noreferrer">www.easyhosting.lv
      </a>), Riga Latvija.
    </p>
  </section>
</section>
<section>
  <h2>PRIVACY POLICY
  </h2>
  <p>This privacy policy applies only to our website and the micro-sites (sub-websites). If you click on a link to any
    other website, you should read their privacy policy.
  </p>
  <p>InnoCAPE is committed to the protection of personal data. We do our best to process your personal data in
    conformity with the
    <a target="_blank" href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679"
      rel="noopener noreferrer">General Data Protection Regulation
    </a>. This privacy policy explains how we use the personal data we collect from you when you engage with our
    project, for example by using our website, joining our events or implementing the online tools created by the
    project partners.
  </p>
  <p>InnoCAPE collects personal data of those using our online tools and website pages dedicated for the Digital
    Maturity Assessment (DMA) and Competence Map (CMAP), and processes it with due care, in accordance with all
    applicable requirements established by the Law on Legal Protection of Personal Data of the Republic of Lithuania and
    other legal as of the Republic of Lithuania, regulating personal data management and protection.
  </p>
  <section>
    <h3>i) Personal data processed and sources of data
    </h3>
    <p>InnoCAPE collects the following types of information from our Users: (i) User Data; and (ii) Technical Data.
      Although we do not normally use Technical Data to identify you as an individual, you can sometimes be recognized
      from it. In such situations, Technical Data can also be considered personal data under applicable laws.
    </p>
    <p>Through the InnoCAPE DMA or CMAP, we may collect and process the following User Data about our participants and
      visitors: (i) first and last name; (ii) address details, (iii) telephone number, (iv) e-mail address, (v) your
      location when you use our services, (vi) educational institution or special skills within the workplace, (vii)
      company data (description,website address, social media links etc.).
    </p>
    <p>InnoCAPE may collect User Data from our participants and visitors in a variety of ways, including, when they
      register to our services or on-line tools, i.e. DMA and CMAP, subscribe to a newsletter, register to one of our
      events or fill out a form.
    </p>
    <p>InnoCAPE and/or our authorized third party service providers, may automatically collect Technical Data when you
      visit or interact with our services or sites. Technical Data may include the browser name, the type of computer or
      device, time spent on a website, interaction with the Services, the time and date of user visits, surfing habits,
      IP address, operating system and other similar technical information.
    </p>
    <p>We use various technologies to collect and store public information when you use InnoCAPE DMA and CMAP websites
      (including Cookies, Google Tags, Analytics etc.).
    </p>
    <p>Cookies allow us to calculate the aggregate number of people visiting our websites and monitor the use of the
      website. We also use cookies that make the use of the website easier for you, for example by remembering
      usernames, passwords and (language) preferences. We also use tracking and analytics cookies to see how well our
      services are being received by our users.
    </p>
    <p>You may choose to set your web browser to refuse cookies, or to alert you when cookies are being sent. If you do
      so, note that some parts of our site and services may not function properly. For more information about cookies
      and how to delete them, visit
      <a target="_blank" href="https://www.allaboutcookies.org" rel="noopener noreferrer">www.allaboutcookies.org
      </a>.
    </p>
    <p>Our site uses Google Analytics and other web analytics services (like Google Tag manager) to compile reports on
      visitor usage and to help us improve our site and services. For an overview of Google Analytics, please visit
      <a target="_blank" href="https://www.google.com/analytics/"
        rel="noopener noreferrer">http://www.google.com/analytics/
      </a>. For an overview of Google Tag manager, please visit:
      <a target="_blank" href="https://support.google.com/tagmanager/answer/6102821?hl=en"
        rel="noopener noreferrer">https://support.google.com/tagmanager/answer/6102821?hl=en
      </a>
    </p>
  </section>
  <section>
    <h3>ii) Purposes and legitimate grounds for the processing of your personal data
    </h3>
    <p>There are several purposes of the processing of your personal data by InnoCAPE:
    </p>
    <p>To provide our services and carry out our agreement with you, InnoCAPE processes your personal data in the first
      place to be able to deliver our services to you. This includes processing data generated from using the digital
      maturity assessment tool in a depersonalized and aggregated form to analyze the state of digitalization across
      industries and geographical areas. We also use the data to contact you, should you so choose, for further
      assistance following your digital maturity assessment.
    </p>
    <p>InnoCAPE processes your personal data as a part of customer communication to contact you regarding our services
      and to inform you of changes to our services. Your data are also used for research and analysis to improve our
      services and our website. We may also use your data entered on our website in certain cases to send information by
      email about the project, provided that you have given us consent to do so.
    </p>
  </section>
  <section>
    <h3>iii) Recipients
    </h3>
    <p>We only share your personal data within the organization of InnoCAPE consortium and Managing Authority / Joint
      Secretariat of Interreg Baltic Sea Region programme if and as far as reasonably necessary to perform and develop
      our services and implement the project.
    </p>
    <section>
      <h4>It is necessary for the purposes of this Privacy Statement
      </h4>
      <p>When third parties need access to personal data to perform such services, InnoCAPE has taken the appropriate
        contractual and organizational measures to ensure that your data are processed exclusively for the purposes
        specified in this Privacy Statement and in accordance with all applicable laws and regulations. Furthermore, we
        may provide your personal data to our affiliates or other trusted businesses or persons to process it for us,
        based on our instructions and in accordance with our Privacy Statement and any other appropriate obligations of
        confidentiality and security measures.
      </p>
    </section>
    <section>
      <h4>For legal reasons
      </h4>
      <p>We may share your personal data with third parties outside InnoCAPE if we have a good-faith belief that access
        to and use of the personal data is reasonably necessary to: (i) meet any applicable law, regulation, and/or
        court order; (ii) detect, prevent, or otherwise address fraud, security or technical issues; and/or (iii)
        protect the interests, properties or safety of InnoCAPE, our users or the public as far as in accordance with
        the law. When possible, we will inform you about such processing.
      </p>
    </section>
  </section>
  <section>
    <h3>iv) Data keeping term
    </h3>
    <p>InnoCAPE does not store your personal data longer than is legally permitted and necessary for the purposes for
      which the data were collected. The storage period depends on the nature of the information and the purposes of
      processing. The maximum period for technical data may therefore vary per use as long as we keep our website
      on-line. Finally, we store your personal data for the provision of services for a maximum of five years after the
      Project ends, which for the DMA and CMAP tool means October 2021.
    </p>
  </section>
  <section>
    <h3>v) Your rights
    </h3>
    <section>
      <h4>Right to access data about you
      </h4>
      <p>InnoCAPE offers you access to the personal data we process. This means you can contact us asking us to inform
        you about your personal data that we have collected and processed and the purposes such data are used for.
      </p>
    </section>
    <section>
      <h4>Right to correct data about you
      </h4>
      <p>You have the right to have incorrect/unprecise, incomplete, outdated, or unnecessary personal data we have
        stored about you corrected or completed by contacting us.
      </p>
    </section>
    <section>
      <h4>Right to deletion of your all data
      </h4>
      <p>You may also ask us to delete your personal data from our systems. We will comply with such requests unless we
        have a legitimate ground to not delete the data. After the data has been deleted, we may not immediately be able
        to delete all residual copies from our active servers and backup systems.
      </p>
    </section>
    <section>
      <h4>Right to object to certain use of your data
      </h4>
      <p>You may object to certain use of your personal data if such data are processed for other purposes than
        necessary for the performance of our services or for compliance with a legal obligation. You may also object to
        any further processing of your personal data after prior given consent. If you object to the further processing
        of your personal data, this may lead to poor service provided by us.
      </p>
    </section>
    <section>
      <h4>Right to restriction of processing of your personal data
      </h4>
      <p>You may request us to restrict certain processing of your personal data. If you restrict certain processing of
        your personal data, this may lead to poor service provided by us.
      </p>
    </section>
    <section>
      <h4>Right to data portability
      </h4>
      <p>You have the right to receive your personal data from us in order to transmit the data to another controller.
      </p>
    </section>
    <section>
      <h4>How to use your rights?
      </h4>
      <p>You may use these rights by sending a letter or email, including your name, address, phone number and a copy of
        a valid ID to us on the addresses set out above. In case you consider our processing activities of your personal
        data to be inconsistent with the applicable data protection laws, you may lodge a complaint with the local
        supervisory authority for data protection.
      </p>
    </section>
  </section>
  <section>
    <h3>vi) Information Protection
    </h3>
    <p>We will take all reasonable, appropriate security measures to protect InnoCAPE from unauthorized access to or
      unauthorized alteration, disclosure or destruction of personal data we hold. Measures include, where appropriate,
      encryption, firewalls, secure facilities and access rights systems. Should, despite the security measures, a
      security breach occur that is likely to have negative effects to your privacy, we will inform you about the breach
      as soon as reasonably possible.
    </p>
  </section>
  <section>
    <h3>vii) Changes to our privacy policy
    </h3>
    <p>Privacy Policy is published in English and may change from time to time. You can find the current version on our
      website
      <a target="_blank" href="https://innocape.eu/privacy-policy/"
        rel="noopener noreferrer">https://innocape.eu/privacy-policy/
      </a>. We reserve the right to modify this Privacy Policy at any time. Any changes will be posted on our homepage
      so that you are aware of the changes. This privacy policy was last updated on 1st December, 2020.
    </p>
  </section>
</section>
<section>
  <h2>HOW TO CONTACT US:
  </h2>
  <p>Sunrise Valley Science and Technology Park
  </p>
  <p>Sauletekio ave. 15, LT-10224 Vilnius [Lithuania]
  </p>
  <p>Tel. + 370 640 56547
  </p>
  <p>Email: info@innocape.eu.
  </p>
</section>
`
